import { render, staticRenderFns } from "./GroundTruth.vue?vue&type=template&id=243d0af0&scoped=true&"
import script from "./GroundTruth.vue?vue&type=script&lang=js&"
export * from "./GroundTruth.vue?vue&type=script&lang=js&"
import style0 from "./GroundTruth.vue?vue&type=style&index=0&id=243d0af0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d0af0",
  null
  
)

export default component.exports